﻿import {useMemo} from 'react';
import {SupplierActivitySummaryVo} from "../../../types/supplier/SupplierActivitySummaryVo";
import {supplierActivitySummaryReportEndpoints} from "../../../requests/api-endpoints";
import { useReactiveGetRequest } from '../../request/useReactiveGetRequest';

interface UseSupplierActivitySummariesAggregated {
  date?: string;
  locationId: string;
}

const useSupplierActivitySummariesAggregated = ({ date, locationId }: UseSupplierActivitySummariesAggregated) => {
  const queryParams = useMemo(() => ({
    date,
    locationId
  }), [date, locationId]);

  const {
    data: aggregatedSummaries,
    isLoading,
    error,
  } = useReactiveGetRequest<SupplierActivitySummaryVo>({ requestUrl: supplierActivitySummaryReportEndpoints.aggregate, queryParams, shouldAbort: true });

  return {
    aggregatedSummaries,
    isLoading,
    error,
  }
}

export { useSupplierActivitySummariesAggregated };
